const rtlToolDefaults = {
  heading: {
    properties: {
      textAlign: { value: 'right' },
    },
  },
  paragraph: {
    properties: {
      textAlign: { editor: { defaultValue: 'right' } },
    },
  },
  text: {
    properties: {
      textAlign: { editor: { defaultValue: 'right' } },
    },
  },
  table: {
    properties: {
      headerTextAlign: { value: 'right' },
      contentTextAlign: { value: 'right' },
      footerTextAlign: { value: 'right' },
    },
  },
}

export const getUnlayerRtlConfig = (isRtl) => ({
  ...(isRtl && { textDirection: 'rtl' }),
  features: {
    textEditor: {
      ...(isRtl && { textDirection: true }),
    },
  },
  appearance: {
    panels: {
      tools: {
        dock: isRtl ? 'right' : 'left',
      },
    },
  },
  tools: isRtl ? rtlToolDefaults : {},
})

export const applyUnlayerRtlConfig = (config, isRtl) => {
  const rtl = getUnlayerRtlConfig(isRtl)
  return {
    ...config,
    ...(rtl.textDirection && { textDirection: rtl.textDirection }),
    features: {
      ...config.features,
      textEditor: {
        ...config.features?.textEditor,
        ...rtl.features?.textEditor,
      },
    },
    appearance: {
      ...config.appearance,
      panels: {
        ...config.appearance?.panels,
        tools: {
          ...config.appearance?.panels?.tools,
          ...rtl.appearance?.panels?.tools,
        },
      },
    },
    tools: {
      ...config.tools,
      ...rtl.tools,
    },
  }
}

export const isCampaignRtl = (direction) => direction === 'rtl'
